import domain from '@/service/domain'
import router from "@/router/index"
import tools from '@/utils/tools.js'
import { getAuthInfo, getLockerrCode } from '@/api/index'
import store from '../store'
export const mapMenu = {
  // 众筹二级菜单
    pro: [
      {
        name:'项目概览',
        type: 'index',
        path: 'index',
      },
      {
        name:'编辑项目',
        type: 'initiate',
        path: 'initiate'
      },
      {
        name:'项目更新',
        type: 'update',
        path: 'update/index'
      },
      {
        name:'常见问题',
        type: 'question',
        path: 'question'
      },
      {
        name:'数据分析',
        type: 'analysis',
        path: 'analysis'
      },
      {
        name:'订单管理',
        type: 'order',
        path: 'order'
      },
      {
        name:'发货管理',
        type: 'deliver',
        path: 'deliver'
      },
      {
        name:'售后管理',
        type: 'after_sale',
        path: 'after_sale'
      },
      {
        name:'结算管理',
        type: 'settlement',
        path: 'settlement/index'
      },
      {
        name:'结算费率',
        type: 'settlementRate',
        path: 'settlement/rate'
      },
      {
        name:'宣传链接',
        type: 'link',
        path: 'link'
      }
    ],
  // 微打赏二级菜单
    wds: [
      {
        name:'项目概览',
        type: 'index',
        path: 'index'
      },
      {
        name:'编辑项目',
        type: 'initiate',
        path: 'initiate'
      },
      {
        name:'项目更新',
        type: 'update',
        path: 'update/index'
      },
      {
        name:'常见问题',
        type: 'question',
        path: 'question'
      },
      {
        name:'数据分析',
        type: 'analysis',
        path: 'analysis',
      },
      {
        name:'订单管理',
        type: 'order',
        path: 'order',
      },
      {
        name:'发货管理',
        type: 'deliver',
        path: 'deliver'
      },
    ],
    others:[
      {
        name:'客户管理',
        icon: 'icon-client',
        child:[
          {
            name:'客户分组',
            path: `${domain.center}/ucenter/user_manage?from=cp`
          }
        ]
      },
      {
        name:'运营管理',
        icon: 'icon-operator',
        child:[
          {
            name:'推广记录',
            path: '/operate_manage/spread'
          },
          {
            name:'抽奖管理',
            path: '/operate_manage/drawtool'
          },
          {
            name:'投票管理',
            path: '/operate_manage/vote',
          },
          {
            name:'任务中心',
            path: '/operate_manage/task',
            isDot: !localStorage.getItem('taskCompleted')
          },
          {
            name:'推广服务',
            path: '/operate_manage/gold',
            isDot: !localStorage.getItem('goldCompleted')
          }
        ]
      },
      {
        name:'客服管理',
        icon: 'icon-customer',
        child:[
          {
            name:'客服消息',
            path: `${domain.account}/RongIM`
          },
          {
            name:'客服子账号',
            path: `${domain.account}/CustomerService/manageIndex`
          }
        ]
      },
      {
        name:'账户管理',
        icon: 'icon-account',
        child:[
          {
            name:'账号认证',
            methods: () => {
              getAuthInfo({}).then(res => {
                let auth_status = res.auth_status;
                let auth_cate = res.auth_cate;
                let history_pass = res.history_pass;
                if (Number(history_pass) == 1) {
                  if(auth_cate == 11){
                    window.open(domain.me + '/u/user_self_edit?uid='+store.state.user.user_id+'&from=cp')
                  }else{
                    window.open(domain.me + '/u/user_auth_view?uid='+store.state.user.user_id+'&from=cp')
                  }
                }else{
                  if(auth_status == 0){
                    window.open(`${domain.www}/identity/type`)
                  }else if(auth_status == 100){
                      if(history_pass == 1){
                        window.open(`${domain.zhongchou}/auth/auth_funds_success?type=me`)
                      }else{
                        window.open(`${domain.zhongchou}/auth/auth_funds_success`)
                      }
                  }else if(auth_status == 201){
                    window.open(`${domain.zhongchou}/auth/auth_refuse_funds`)
                  }else{
                      if(auth_cate == 11){
                        window.open(domain.me + '/u/user_self_edit?uid='+store.state.user.user_id)
                      }else{
                        window.open(domain.me + '/u/user_auth_view?uid='+store.state.user.user_id)
                      }
                  } 
                }
              })
            }
          },
          {
            name: '收款账户',
            // path: `${domain.me}/u/shroff?from=cp`
            path: `/account/payee`,
            type: 'payee'
          },
          {
            name: '公共文档下载',
            path: `${domain.center}/ucenter/download?from=cp`
          },
          {
            name: '发票管理',
            path: `/account/invoice`,
            type: 'invoice'
          }
        ]
      },
      {
        name:'发起者必看',
        icon: 'icon-page',
        child:[
          {
            name:'项目规范',
            path: `${domain.zhongchou}/about/index/2/2.html`
          },
          {
            name:'众筹资质要求',
            path: `${domain.zhongchou}/about/index/2/6.html`
          },
          {
            name:'发起者协议',
            path: `${domain.zhongchou}/about/index/3/2.html`
          },
          {
            name:'发起指南',
            path: `${domain.zhongchou}/about/guide`
          }
        ]
      },
      {
        name:'其他业务',
        icon: 'icon-other_business',
        child:[
          {
            name:'我的小店',
            path: `${domain.center}/product`
          },
          {
            name:'数字藏品',
            methods: () => {
              if (store.state.user.user_id) {
                getLockerrCode().then(res => {
                  if (res.status == 0) {
                    window.open(`https://shop.modianverse.com/#/login?from=modian&code=${res.data.code}`)
                  } else {
                    window.open(`https://shop.modianverse.com/#/login?from=modian`)
                  }
                })
              }
            }
          }
        ]
      }
    ],
    proMenu: {
      '0': ['index', 'initiate', 'update', 'question', 'analysis', 'order', 'after_sale', 'link', 'settlementRate'], // 众筹中
      '1': ['index', 'initiate', 'update', 'question', 'analysis', 'order', 'link', 'settlementRate'], // 预热中
      '2': ['index', 'initiate', 'update', 'question', 'analysis', 'order', 'after_sale', 'link', 'settlementRate'], // 众筹失败
      '3': ['index', 'initiate', 'update', 'question', 'analysis', 'order', 'deliver', 'after_sale', 'settlement', 'link', 'settlementRate'], // 众筹成功
      '6': ['index', 'initiate', 'update', 'question', 'analysis', 'order', 'deliver', 'after_sale', 'settlementRate', 'link'], // 发起者取消
      '7': ['index', 'initiate', 'update', 'question', 'analysis', 'order', 'deliver', 'after_sale', 'settlementRate', 'link'], // 摩点平台取消
      '8': ['index', 'initiate', 'update', 'question', 'analysis', 'order', 'deliver', 'after_sale', 'link', 'settlementRate'], // 项目中止
      '-3': ['index', 'initiate'], // 准备中
      '-2': ['index', 'initiate', 'settlementRate'], // 审核拒绝
      '-5': ['index', 'initiate', 'settlementRate'], // 审核待修改
      '10': ['index', 'initiate', 'settlementRate'], // 审核通过待上线
      '-1': ['index', 'initiate'], // 待审核
      '-4': [], // 项目已删除
      '12': [], // 项目下线
      '13': ['index', 'initiate', 'update', 'question', 'analysis', 'order', 'link', 'settlementRate'], // 项目公开展示-但未设置开售时间
    },
    wdsMenu: {
      '-1': ['index', 'initiate'], // 待审核
      '-3': ['index', 'initiate'], // 准备中
      '-2': ['index', 'initiate'], // 审核拒绝
      '1': ['index', 'initiate', 'update', 'question', 'analysis', 'order'], // 预热中
      '0': ['index', 'initiate', 'update', 'question', 'analysis', 'order'], // 众筹中
      '2': ['index', 'initiate', 'update', 'question', 'analysis', 'order', 'deliver'], // 众筹结束
      '3': ['index', 'initiate', 'update', 'question', 'analysis', 'order', 'deliver'], // 众筹成功
    },
    wdsActions: {
      '-3': [{// 准备中
          action_name: "编辑项目资料", 
          action_type: "edit"
        },{
            action_name: "删除项目", 
            action_type: "delete"
        },{
          action_name: "提交审核", 
          action_type: "goOld"
      }],
      "-2": [{// 审核拒绝
        action_name: "查看拒绝原因", 
        action_type: "reject_reason"
      },{
          action_name: "编辑项目资料", 
          action_type: "edit"
      },{
          action_name: "删除项目", 
          action_type: "delete"
      }],
      "1": [{// 预热中
          action_name: "编辑项目资料", 
          action_type: "edit"
      }],
      "0": [{// 众筹中
          action_name: "编辑项目资料", 
          action_type: "edit"
      },{
        action_name: "结束项目", 
        action_type: "goOld"
      }]
    }
}

export const getMenu = (key) => {return mapMenu[key]}

export const menuRoute = (path, type, pro_id, obj) => {
    if (path && pro_id) {
      let list = mapMenu[obj.pro_class == '201' ? 'wdsMenu' : 'proMenu'][obj.status_code] || []
      switch(path) {
        case 'initiate': // 编辑项目
          if(obj.pro_class == '201' && mapMenu['wdsMenu'][obj.status_code] && mapMenu['wdsMenu'][obj.status_code].length && mapMenu['wdsMenu'][obj.status_code].includes(type)) {
            window.open(`${domain.member}/initiate/base?id=${pro_id}&from=cp`)
          } else if (mapMenu['proMenu'][obj.status_code] && mapMenu['proMenu'][obj.status_code].includes(type)) {
            if (obj.temp_id) {
              window.open(`${domain.account}/initiate/base?pro_id=0&temp_id=${obj.temp_id}`)
            } else {
              window.open(`${domain.account}/initiate/base?pro_id=${pro_id}&temp_id=0`)
            }
          } else {
            tools.confirm('暂未开启该功能！');
          }
          break;
        case 'settlement/rate': 
          //结算费率跳旧页面
          if (!list.includes(type)) {
            return tools.confirm('暂未开启该功能！');
          } else {
            //window.open(`${domain.www}/project_manage/settlement_rate?id=${pro_id}&from=cp`)
            router.push(`/project_manage/${path}/${pro_id}`);
          }
          break;
        case 'index': 
          if (obj.temp_id) {
            router.push(`/project_manage/${path}/temp/${obj.temp_id}`);
          } else {
            router.push(`/project_manage/${path}/${pro_id}`);
          }
          break;
        default:
          router.push(`/project_manage/${path}/${pro_id}`);
          break;
      }
    }
}
// 路由校验拦截
export const beforeRouter = async (to) => {
  let pro_id = to.params.id || to.query.pro_id || ''
  if (pro_id) {
    if(to.path == `/project_manage/index/temp/${pro_id}` || (sessionStorage.getItem('isTemp') && to.path != `/project_manage/index/${pro_id}`)) {
      let index = store.state.project.proList.findIndex(item =>{
        return item.temp_id == pro_id
      })
      if (index > -1) {
        store.commit('updataProInfo', {
          id: pro_id,
          info: store.state.project.proList[index],
        });
        store.commit('updataAuthority', true);
      } else {
        sessionStorage.removeItem('isTemp')
        location.href = domain.member + '/project_manage/index'
      }
    } else if(pro_id !== store.state.project.proInfo.id) {
      await store.dispatch('getProInfo', pro_id)
    }
  } else {
    store.commit('updataProInfo', {
      id: '',
      info: {},
    });
  }
}
